import { render } from "./homeAiAide.vue?vue&type=template&id=a6e7497a&scoped=true"
import script from "./homeAiAide.vue?vue&type=script&lang=js"
export * from "./homeAiAide.vue?vue&type=script&lang=js"

import "./homeAiAide.vue?vue&type=style&index=0&id=a6e7497a&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e7497a"]])

export default __exports__